// extracted by mini-css-extract-plugin
export default {"container":"Paths_container__0YbX+","title":"Paths_title__XPoXu","paths":"Paths_paths__cc35L"};